import controller from './suggests.controller'
import template from './suggests.template.html'

export default {
  restrict: 'E',
  replace: true,
  bindings: {
    storyObj: '=',
  },
  require: {
    ngModel: '^ngModel',
  },
  template,
  controller,
  controllerAs: 'vm',
}
